import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const medicalClearanceService = {
  getPreview: async (filterPayload, isProcessorOnly = false) => {
    return await axios.post(`${domain}/api/MedicalClearance/preview?isProcessorOnly=${isProcessorOnly}`, filterPayload, { headers });
  },

  getClearanceDetails: async (headerId) => {
    return await axios.get(`${domain}/api/MedicalClearance/${headerId}/details`, { headers });
  },

  getActiveRequirements: async () => {
    return await axios.get(`${domain}/api/ClinicRequirements/active`, { headers });
  },

  createAssignment: async (payload) => {
    return await axios.post(`${domain}/api/MedicalClearance`, payload, { headers });
  },

  updateAssignment: async (id, payload) => {
    return await axios.put(`${domain}/api/MedicalClearance/${id}`, payload, { headers });
  },

  releaseAssignment: async (id, userId) => {
    return await axios.put(`${domain}/api/MedicalClearance/${id}/release`, { updatedBy: userId }, { headers });
  },

  updateBatchDetails: async (headerId, updates) => {
    return await axios.put(`${domain}/api/MedicalClearance/${headerId}/batch-details`, updates, { headers });
  },

  finalizeClearance: async (headerId, userId) => {
    return await axios.put(`${domain}/api/MedicalClearance/${headerId}/finalize`, { updatedBy: userId }, { headers });
  },

  deleteAssignment: async (id) => {
    return await axios.delete(`${domain}/api/MedicalClearance/${id}`, { headers });
  }
};